import loadable from "@loadable/component";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import PaymentMethodIcon from "../../Icons/PaymentMethodIcon";
import APIS from "../../constant/Endpoint";
import useDeleteHook from "../../customHooks/useDeleteHook";
import usePostHook from "../../customHooks/usePostHook";
const PaymentMethodListComponent = loadable(
  () => import("../../components/PaymentMethod/PaymentMethodList")
);

const PaymentMethodList = () => {
  const { mutateAsync, isLoading } = useDeleteHook({
    queryKey: ["roles"],
  });

  const { mutateAsync: patchUser, isPostLoading } = usePostHook({
    queryKey: ["payment-method"],
    navigateURL: "",
  });

  const handleDelete = async (
    id: any,
    setOpenDeletePopup: any,
    setError: any
  ) => {
    const url = `${APIS.PAYMENT_METHOD}${id}/`;
    let formData = {};
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 204) {
        setOpenDeletePopup(false);
      }
    } catch (err) {
      console.error(err);
    }
  };
  const handleToogle = async (value: boolean, id: any) => {
    const url = `${APIS.PAYMENT_METHOD}${id}/toggle/`;
    const formData = {
      is_merchant_required: value,
    };
    try {
      await patchUser({ url, formData });
    } catch (e) {
      console.log(e);
    }
  };
  const handleTendorToggle = async (value: boolean, id: any) => {
    const url = `${APIS.PAYMENT_METHOD}${id}/toggle/`;
    const formData = {
      is_tender_required: value,
    };
    try {
      await patchUser({ url, formData });
    } catch (e) {
      console.log(e);
    }
  };
  const handleQrToggle = async (value: boolean, id: any) => {
    const url = `${APIS.PAYMENT_METHOD}${id}/toggle/`;
    const formData = {
      is_generate_qr: value,
    };
    try {
      await patchUser({ url, formData });
    } catch (e) {
      console.log(e);
    }
  };
  const handleActive = async (value: boolean, id: any) => {
    const url = `${APIS.PAYMENT_METHOD}${id}/toggle/`;
    const formData = {
      is_active: value,
    };
    try {
      await patchUser({ url, formData });
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <PaymentMethodIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Payment Method
        </span>
      </div>
      <PaymentMethodListComponent
        handleDelete={handleDelete}
        isLoading={isLoading}
        handleActive={handleActive}
        handleToogle={handleToogle}
        handleTendorToggle={handleTendorToggle}
        handleQrToggle={handleQrToggle}
      />
    </>
  );
};

export default PaymentMethodList;
